
namespace RioERP.Carts {

    @Serenity.Decorators.registerClass()
    export class CounterProductsGrid extends Serenity.EntityGrid<CounterProductsRow, any> {
        protected getColumnsKey() { return CounterProductsColumns.columnsKey; }
        protected getDialogType() { return CounterProductsDialog; }
        protected getIdProperty() { return CounterProductsRow.idProperty; }
        protected getInsertPermission() { return CounterProductsRow.insertPermission; }
        protected getLocalTextPrefix() { return CounterProductsRow.localTextPrefix; }
        protected getService() { return CounterProductsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected createToolbarExtensions() {
            super.createToolbarExtensions?.();

            const editItem = this.editItem.bind(this);

            // Card view setup
            const cardView = new Serenity.CardViewMixin<FranchiseeProductsRow>({
                grid: this,
                renderItem: (item, index) => React.createElement(FranchiseeProductCard, {
                    item: item,
                    editItem: editItem
                })
            });

            // Show card view by default
            setTimeout(() => {
                cardView.switchView('card'); // 'true' enables card view
            }, 200);

            // Create button and append to toolbar
            const $goToCartBtn = $('<button class="go-to-cart-btn">🛒 Go To Cart</button>')
                .appendTo(this.toolbar.element)
                .click(() => {
                    CounterCartService.RetrieveCounterCart({
                        EntityId: 1
                    }, response => {
                        if (response.Entity == null) {
                            Q.notifyError("No Data found in cart");

                        } else {
                            let dlg = new CounterCartDialog();
                            dlg.loadByIdAndOpenDialog(response.Entity.Id);
                        }
                    });
                });

            // 🔢 Get product count and update button text
            CounterCartService.RetrieveCounterCart({
                EntityId: 1
            }, response => {
                if (response.Entity != null && response.Entity.CartProducts?.length > 0) {
                    const count = response.Entity.CartProducts.length;
                    $goToCartBtn.text(`🛒 Go To Cart (${count})`);

                }

            });
        }
    }
}